import { jwtDecode } from 'jwt-decode';
import { UserType } from 'server/src/apps/jwtAuth/employeeSessionUserType';

export type LoginAsBehalfInfo = {
  type: UserType;
  id: string | null;
  name: string;
};

type JwtPayload = {
  loginAsBehalf?: LoginAsBehalfInfo;
};

export const getLoginAsBehalfFromToken = (
  token: string | null,
): LoginAsBehalfInfo | null => {
  if (!token) {
    return null;
  }

  try {
    const jwtToken = token.startsWith('Bearer ') ? token.split(' ')[1] : token;
    const payload = jwtDecode<JwtPayload>(jwtToken);
    return payload.loginAsBehalf || null;
  } catch {
    return null;
  }
};
